export const GetData = async (
  url: string,
  statusCode: number,
  token?: string | null,
  callback?: (response: any) => void
) => {
  let response = await fetch(url, {
    method: 'GET',
  });

  if (response.status !== statusCode) {
    console.log('Looks like there was a problem. Status Code: ' + response.status);
    try {
      const jsonResponse = await response.json();
      return jsonResponse;
    } catch (e) {
      console.log('Server Error => ', e);
      return response;
    }
  } else {
    const jsonResponse = await response.json();

    if (callback) {
      callback(jsonResponse);
    }

    return jsonResponse;
  }
};
